import { UI, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Box } from 'native-base';
import { useRecoilState } from 'recoil';

import { SignedInNavigationScreenNavigationProp } from '../../../../../routes/types';
import { managementAnalysisFiltersAtom } from '../../../../../store/managementAnalysisDetails/filters';

export interface FilterButtonProps {
  isMobile: boolean;
}

export const FilterButton = ({ isMobile }: FilterButtonProps) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const [{ appliedFilters, availableFilters }] = useRecoilState(managementAnalysisFiltersAtom);

  if (!availableFilters.length) {
    return <></>;
  }

  return (
    <UI.Button
      onPress={() => navigate('ManagementAnalysisDetailsModalFilter')}
      paddingX={Spacing['inline.xxxs']}
      variant="secondary"
      {...(!appliedFilters.length &&
        !isMobile && {
          rightIcon: <UI.Icon testId="filter-icon" name={'Funnel'} size="xxxs" />,
        })}>
      <HStack alignItems="center" justifyContent="center" space={Spacing['inline.nano']}>
        <UI.Text variant="semibold" fontSize={Typography['fontsize.md']}>
          {isMobile ? 'Filtrar' : 'FILTRO'}
        </UI.Text>
        {!!appliedFilters.length && (
          <Box
            rounded={'full'}
            w={'20px'}
            h={'20px'}
            alignItems={'center'}
            justifyContent={'center'}
            bg={'brand.tertiary.light'}>
            <UI.Text variant="regular" fontSize={Typography['fontsize.xs']} color={'neutral.white'}>
              {appliedFilters.length}
            </UI.Text>
          </Box>
        )}
      </HStack>
    </UI.Button>
  );
};
